import React, { Component } from "react";
import { Badge } from "react-bootstrap";
import AuthService from "services/auth.service";

import ProfileImage from "./ProfileImage";
import ImgEmptyChat from "assets/images/empty-chats.png";
import IconExpiry from "assets/icons/expiry-icon.svg";
import moment from "moment";
import { getPatientName } from "helpers/teleconsult.helper";

export class ChatList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_chat_id: null,
      lists: this.props.chats,
    };
  }

  onChatClick(chat, index) {
    const newLists = this.state.lists.map((obj, i) => {
      if (i === index) {
        return { ...obj, read_by_doctor: true };
      }
      return obj;
    });
    this.setState({ selected_chat_id: chat.id, lists: newLists });
    this.props.setSelectedChat(chat);
  }

  render() {
    const getChatCategoryName = (chat) => {
      if (chat.chat_category_name === "BookDoc-Nutritionist") {
        return <>Nutrition</>;
      }

      if (chat.chat_category_name === "NOP-Nutritionist") {
        return "NESTLÉ®";
      }
      if (chat.chat_category_name) {
        return <>{chat.chat_category_name}</>;
      }
      return <>Others</>;
    };

    const getChatTime = (chat) => {
      const { video_session, start_at: chatStartAt, end_at: chatEndAt } = chat;
      const start_at = video_session ? video_session.start_at : chatStartAt;
      const end_at = video_session ? video_session.end_at : chatEndAt;

      const startDate = moment.unix(start_at).format("D MMMM YYYY");
      const startTime = moment.unix(start_at).format("h:mm A");
      const endTime = moment.unix(end_at).format("h:mm A");

      let date = "";
      let time = "";

      if (end_at === 0 || start_at === end_at) {
        date = startDate;
        time = startTime;
      } else {
        date = startDate;
        time = `${startTime} - ${endTime}`;
      }

      const currentTime = moment().unix();
      const chatStatus =
        currentTime > end_at
          ? end_at === 0
            ? "ongoing"
            : "history"
          : "ongoing";

      return (
        <div className={chatStatus}>
          {date} • {time}
        </div>
      );
    };

    const ChatStatus = (chat) => {
      if (chat.video_session) {
        if (chat.video_session.is_cancelled) {
          return <span className="chat-status">Cancelled</span>;
        } else {
          let start_at = chat.video_session.start_at;
          let end_at = chat.video_session.end_at;

          if (new moment().unix() > end_at)
            return <span className="chat-status">Session Ended</span>;
          else if (new moment().unix() < start_at) {
            // if theres chat buffer, it applies to both chat and video.
            // shows start indicator only when theres buffer

            if (chat.isInBuffer) {
              var duration = new moment.unix(start_at).diff(
                new moment(),
                "minutes",
              );
              var durationMsg = `Starts in ${duration} mins`;
              if (duration > 60) {
                durationMsg = `Starts in ${new moment(start_at * 1000).diff(
                  new moment(),
                  "hours",
                )} hours `;
                if (duration % 60 !== 0) {
                  durationMsg += (duration % 60) + " minutes";
                }
              }
              return (
                <span className="chat-status ml-2 start-at">{durationMsg}</span>
              );
            } else if (chat.is_premium_plus_chat_session) {
              return (
                <span className="ml-2 start-time">
                  {new moment.unix(start_at).format("DD MMM, hh:mm")}
                </span>
              );
            } else {
              let startsIn = moment.unix(chat.start_at).fromNow();
              return <div>Session starts {startsIn}</div>;
            }
          }
        }
      }
      return null;
    };

    const currentUser = AuthService.getCurrentUser();

    const ChatBadge = ({ chat }) => {
      if (!currentUser?.is_bookdoc_nutritionist) {
        return <></>;
      }

      if (chat.chat_category_name === "NOP-Nutritionist") {
        return <></>;
      }

      const programmeDetails = chat.programme_details;

      // Debugging log to check the values of premium_plus and programme_details
      console.log(`[Chat ID: ${chat.id}] User Plan Badge:`, {
        premium_plus: chat.premium_plus,
        programme_details: programmeDetails
      });

      if (!programmeDetails || !programmeDetails.programme_type) {
        return <></>;
      }

      if (programmeDetails.programme_type === "premium_plus") {
        if (programmeDetails.package === "three_months") {
          return (
            <Badge className="chat-badge">
              <div className="three-months rounded-pill">Premium+</div>
            </Badge>
          );
        } else if (programmeDetails.package === "ninety_days_mom") {
          return (
            <Badge className="chat-badge">
              <div className="ninety-days-mom rounded-pill">90DaysMom</div>
            </Badge>
          );
        } else {
          return (
            <Badge className="chat-badge">
              <div className="trial rounded-pill">Trial</div>
            </Badge>
          );
        }
      } else {
        return (
          <Badge className="chat-badge">
            <div className="premium rounded-pill">Premium</div>
          </Badge>
        );
      }
    };

    const name = (chat) => {
      if (chat?.appointment_info && !chat?.appointment_info?.is_me) {
        return (
          <div className="name text-capitalize">
            {getPatientName(chat)} <i className="dependent">(dependent)</i>
          </div>
        );
      } else {
        return (
          <div className="name text-capitalize">{getPatientName(chat)}</div>
        );
      }
    };

    const TimeLeft = ({ chat }) => {
      const ExpiredAt = chat.programme_details?.expiry_date;
      if (!ExpiredAt) return null;

      const expiryDate = moment(ExpiredAt);
      if (!expiryDate.isValid()) return null;

      const daysDiff = moment().diff(expiryDate, "days");

      if (daysDiff > -7 && daysDiff <= 0) {
        return (
          <span className="expiry-date">
            <img src={IconExpiry} alt="expiry-icon" className="pr-1" />
            {moment().to(expiryDate)}
          </span>
        );
      } else {
        return (
          <span className="expiry-date">
            <img src={IconExpiry} alt="expiry-icon" className="pr-1" />
            {expiryDate.format("DD MMM YYYY")}
          </span>
        );
      }
    };

    return (
      <div className="chats-container scrollbar-grey">
        {(() => {
          if (this.props.chats.length === 0) {
            return (
              <div className="w-100 p-3 text-center">
                <img
                  src={ImgEmptyChat}
                  className="w-100 mb-3"
                  alt="empty-chat-img"
                />
                <p className="empty-chat-text">
                  You have no {this.props.chatType} chats
                </p>
                <p className="empty-chat-subtext">
                  Start by promoting your chat service to your patients and
                  network.
                </p>
              </div>
            );
          } else {
            return (
              <React.Fragment>
                {this.state.lists.map((chat, index) => (
                  <div
                    className={`chat-row row ${
                      this.state.selected_chat_id === chat.id ? "active" : ""
                    }`}
                    key={`chat-session-${index}`}
                    onClick={() => this.onChatClick(chat, index)}
                  >
                    <div className="chat-notification">
                      {chat.read_by_doctor === false && (
                        <span className="unread-icon"></span>
                      )}
                    </div>{" "}
                    <div className="chat-content">
                      <div className="chat-img">
                        <ProfileImage chat={chat} icon={true} />
                      </div>
                      <div className="chat-info">
                        <div className="desc">
                          <div className="row">
                            <Badge className="chat-badge">
                              <div
                                className={`chat-category${chat.chat_category_name === "NOP-Nutritionist" ? " nestle" : ""}`}
                              >
                                {getChatCategoryName(chat)}
                              </div>
                            </Badge>
                            <ChatBadge chat={chat}></ChatBadge>
                          </div>
                          {/* <span className="chat-date">
                            {getStartDate(chat.start_at)}
                          </span> */}
                        </div>
                        <div className="chat-main-info">
                          <div className="name text-capitalize">
                            {name(chat)}
                          </div>
                        </div>
                        <div className="chat-sub-info">{getChatTime(chat)}</div>
                        <div className="chat-sub-info-time">
                          {ChatStatus(chat)}
                        </div>
                        <div className="chat-time-info">
                          {currentUser?.is_bookdoc_nutritionist && ( 
                              <TimeLeft chat={chat}></TimeLeft>
                            )}
                        </div>
                      </div>
                    </div>
                    <hr className="chat-divider" />
                  </div>
                ))}
              </React.Fragment>
            );
          }
        })()}
      </div>
    );
  }
}
